export type WhatsAppParams = {
    number: string;
    text: string;
}

export function getUniversalWhatsAppLink( params: WhatsAppParams ): URL {
    const url = new URL( `https://wa.me/${params.number}` );
    url.searchParams.set( 'text', params.text );
    return url;
}

function getNativeWhatsAppLink( params: WhatsAppParams ): URL {
    const url = new URL( 'whatsapp://send/' );
    url.searchParams.set( 'phone', params.number );
    url.searchParams.set( 'text', params.text );
    return url;
}

export function getWhatsAppURLForDevice( params: WhatsAppParams ): URL {
    if ( window.innerWidth < 768 ) {
        return getNativeWhatsAppLink( params );
    }

    return getUniversalWhatsAppLink( params );
}
